import React, { useState, useEffect } from 'react';
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { Toaster } from 'sonner';
import SplashScreen from './components/SplashScreen';

import LandingPage from './pages/LandingPage';
import AboutPage from './pages/AboutPage';
import VideosPreviewPage from './pages/VideosPreviewPage';
import Dashboard from './pages/Dashboard';
import VideosPage from './pages/VideosPage';
import QuizPage from './pages/QuizPage';
import WordSearchPage from './pages/WordSearchPage';
import ProfilePage from './pages/ProfilePage';
import UpgradePage from './pages/UpgradePage';
import PaymentHistoryPage from './pages/PaymentHistoryPage';
import SettingsPage from './pages/SettingsPage';

import AdminDashboard from './pages/admin/AdminDashboard';
import AdminUsers from './pages/admin/AdminUsers';
import AdminVideos from './pages/admin/AdminVideos';
import AdminQuiz from './pages/admin/AdminQuiz';
import AdminWordSearch from './pages/admin/AdminWordSearch';
import AdminAbout from './pages/admin/AdminAbout';
import AdminPayments from './pages/admin/AdminPayments';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin h-8 w-8 border-4 border-primary border-t-transparent rounded-full" />
      </div>
    );
  }

  return user ? children : <Navigate to="/" replace />;
};

const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin h-8 w-8 border-4 border-primary border-t-transparent rounded-full" />
      </div>
    );
  }

  if (!user) return <Navigate to="/" replace />;
  if (!user.is_admin) return <Navigate to="/dashboard" replace />;
  
  return children;
};

function AppRoutes() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin h-8 w-8 border-4 border-primary border-t-transparent rounded-full" />
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/sobre" element={<AboutPage />} />
      <Route path="/videos-preview" element={<VideosPreviewPage />} />
      
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/videos"
        element={
          <ProtectedRoute>
            <VideosPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/quiz"
        element={
          <ProtectedRoute>
            <QuizPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/caca-palavras"
        element={
          <ProtectedRoute>
            <WordSearchPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/perfil"
        element={
          <ProtectedRoute>
            <ProfilePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/upgrade"
        element={
          <ProtectedRoute>
            <UpgradePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/historico-pagamentos"
        element={
          <ProtectedRoute>
            <PaymentHistoryPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/configuracoes"
        element={
          <ProtectedRoute>
            <SettingsPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin"
        element={
          <AdminRoute>
            <AdminDashboard />
          </AdminRoute>
        }
      />
      <Route
        path="/admin/users"
        element={
          <AdminRoute>
            <AdminUsers />
          </AdminRoute>
        }
      />
      <Route
        path="/admin/videos"
        element={
          <AdminRoute>
            <AdminVideos />
          </AdminRoute>
        }
      />
      <Route
        path="/admin/quiz"
        element={
          <AdminRoute>
            <AdminQuiz />
          </AdminRoute>
        }
      />
      <Route
        path="/admin/wordsearch"
        element={
          <AdminRoute>
            <AdminWordSearch />
          </AdminRoute>
        }
      />
      <Route
        path="/admin/about"
        element={
          <AdminRoute>
            <AdminAbout />
          </AdminRoute>
        }
      />
      <Route
        path="/admin/payments"
        element={
          <AdminRoute>
            <AdminPayments />
          </AdminRoute>
        }
      />
    </Routes>
  );
}

function App() {
  const [showSplash, setShowSplash] = useState(true);

  if (showSplash) {
    return <SplashScreen onComplete={() => setShowSplash(false)} />;
  }

  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
